<app-donut-chart
  [series]="series"
  [loading]="isLoading"
  [options]="options"
></app-donut-chart>
